import React from 'react';

import { Box, FormField, Label, TextButton } from '@zillow/constellation-10';

import type { Section } from '../../../models';
import { TENANT_PROTECTION } from '../../../constants';
import YesAndNo from '../../../components/Widgets/YesAndNo';
import InlineTooltip from '../../Widgets/InlineTooltip';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function TenantProtection({ section, setSectionValues }: Props) {
  function onNoTenantProtection(): void {
    setSectionValues({
      [TENANT_PROTECTION.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesTenantProtection(): void {
    setSectionValues({
      [TENANT_PROTECTION.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  return (
    <>
      <FormField
        required
        label={
          <Label>
            Is the property covered by the{' '}
            <InlineTooltip
              shouldCloseOnOutsideClick={false}
              tooltipBodyText={
                <>
                  AB 1482 caps annual rent increases at 5% plus the rate of inflation, and requires landlords to show a
                  &quot;just cause&quot; to evict tenants who have lived in your property for 12 months or more. Most
                  housing located in the state of California is covered by AB 1482 unless it falls into one of the
                  categories of exemptions.
                  <Box css={{ display: 'flex', marginTop: 'layout.tighter' }}>
                    <TextButton asChild>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://sfrb.org/article/summary-ab-1482-california-tenant-protection-act-2019"
                      >
                        Learn more
                      </a>
                    </TextButton>
                  </Box>
                </>
              }
            >
              California Tenant Protection Act of 2019 (AB 1482)
            </InlineTooltip>
            ?
          </Label>
        }
        control={
          <YesAndNo
            yesHandler={onYesTenantProtection}
            noHandler={onNoTenantProtection}
            yesActive={section.getFieldValue(TENANT_PROTECTION.FIELD_NAME.IS_ENABLED)}
          />
        }
      />
    </>
  );
}

TenantProtection.description =
  'Asks whether or not the property is under AB 1482 (California Tenant Protection Act of 2019)';

export default TenantProtection;
